import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Additional Advances",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.header"
      }
    ]
  },
  additionalAdvanceAllocations: {
    label: "Additional Advance Allocations",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.additionalAdvanceAllocations",
        multiline: true,
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.additionalAdvanceAllocations"
      }
    ]
  },
  noticeForAdvance: {
    label: "Notice for Advance",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.noticeForAdvance",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.noticeForAdvance"
      }
    ]
  },
  frequencyOfDraws: {
    label: "Frequency of Draws",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.drawFrequency",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.drawFrequency"
      }
    ]
  },
  drawThresholdIntervals: {
    label: "Draw Threshold/Intervals",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.drawThresholdInterval",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.drawThresholdInterval"
      }
    ]
  },
  conditionsForDraws: {
    label: "Conditions for Draws",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.drawConditions",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.drawConditions"
      }
    ]
  },
  requiredEquity: {
    label: "Required Equity",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.requiredEquity",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.requiredEquity"
      }
    ]
  },
  completion: {
    label: "Completion",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.completion",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.completion"
      }
    ]
  },
  covenants: {
    label: "Covenants",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.covenants",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.covenants"
      }
    ]
  },
  restorationRetainage: {
    label: "Restoration/Retainage",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.restorationRetainage",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.restorationRetainage"
      }
    ]
  },
  developmentFee: {
    label: "Development Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "additionalAdvances.developmentFee",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.developmentFee"
      }
    ]
  },
  budgetCostOverruns: {
    label: "Budget/Cost Overruns",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.budgetCostOverruns",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.budgetCostOverruns"
      }
    ]
  },
  changeOrders: {
    label: "Change Orders",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.changeOrders",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.changeOrders"
      }
    ]
  },
  misc: {
    label: "Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "additionalAdvances.misc",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.additionalAdvances.misc"
      }
    ]
  }
};
